import Envirotainer from "./Envirotainer/Envirotainer";
import PT300 from "./PT300/PT300";
import { Device } from "./Device";

export const parseDevice = (data: any): Device | null => {
  const deviceType: string = data.data["type"]?.toUpperCase() || "";
  switch (deviceType) {
    case "ENVIROTAINER": {
      return new Envirotainer(data);
    }
    case "PT300D":
    case "PT300": {
      return new PT300(data);
    }
    default:
      return new Envirotainer(data);
  }
};
